<script>
import { mdiClose } from '@mdi/js'

export default {
  name: 'UpdateRoom',
  setup() {
    const commoditiesList = [
      {
        label: 'Wifi',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Un wifi haut débit pour rester connecté.',
      },
      {
        label: 'Double chambre',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Deux chambres bien équipés.',
      },
      {
        label: 'Cuisine Moderne équipé',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Une Cuisine avec toutes les commodités.',
      },
      {
        label: 'Cuisine Moderne équipé',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Une Cuisine avec toutes les commodités.',
      },
      {
        label: 'Chauffe eau',
        icon: 'fa fa-wifi fa-2x',
        desc: 'Une Douche équipé d\'un de système de chauffe eau .',
      },
      {
        label: 'Tv',
        icon: 'fa fa-tv fa-2x',
        desc: 'Un écran Tv Plasma avec abonnement canal +.',
      },
      {
        label: 'Climatisation',
        icon: 'fa fa-fan fa-2x',
        desc: 'Une climatisation fonctionnel.',
      },
      {
        label: '2 Tv',
        icon: 'fa fa-tv fa-2x',
        desc: 'Deux écrans Tv Plasma pour chaque pièce avec abonnement canal +.',
      },
      {
        label: 'Deux douche',
        icon: 'fa-bathtub fa-2x',
        desc: 'Deux douches de haut standing pour chaque chambre avec toutes les commodités.',
      },
      {
        label: 'Une douche',
        icon: 'fa-bathtub fa-2x',
        desc: 'Une douches de haut standing avec toutes les commodités.',
      },
      {
        label: 'Salle de gym',
        icon: 'fa-heart fa-2x',
        desc: 'Un accès gratuit à une salle de gymnase bien équipée.',
      },
      {
        label: 'Petit-déjeuner',
        icon: 'fa fa-coffee fa-2x',
        desc: 'Un petit déjeuner offer.',
      },
      {
        label: 'Salle de jeu',
        icon: 'fa fa-child fa-2x',
        desc: 'Un espace pour les tout petit.',
      },
    ]

    return {
      icons: { mdiClose },
      commoditiesList,

    }
  },
  props: ['roomToUpdate', 'active'],
  data() {
    return {
      currentRoom: {},
      defaultRoomInputFileValue: undefined,
      apartments: [],
      roomtypes: [],
      roomStatus: [
        {
          label: 'En service',
          code: 30,
        },
        {
          label: 'Hors service',
          code: 500,
        },
        {
          label: 'Occupé',
          code: 405,
        },
      ],
      selectImageToUpdateDialog: false,
      imagesAction: 200,
      imageToUpdate: '',
    }
  },
  mounted() {
    this.loadApartments()
    this.loadRoomTypes()
    this.showEditRoomDialog()
  },
  watch: {
    roomToUpdate(newValue) {
      this.currentRoom = newValue
    },
  },
  methods: {
    closeEditRoomDialog() {
      this.$emit('close-edit', { data: false })
    },
    loadApartments() {
      this.$axios.get(this.$endpoint.LoadApartment).then(rp => {
        this.apartments = rp.data
      })
    },
    photosRoom(imgtable) {
      const finaltable = []
      if (imgtable) {
        imgtable.forEach(src => {
          finaltable.push(`${process.env.VUE_APP_API_ASSET_URL}${src}`)
        })
      }

      return finaltable
    },
    loadRoomTypes() {
      this.$axios.get(this.$endpoint.LoadRoomType).then(rp => {
        this.roomtypes = rp.data
      })
    },
    showEditRoomDialog() {
      this.defaultRoomInputFileValue = new File([], '', undefined)
      this.editRoomDialog = !this.editRoomDialog
      this.imagesAction = 200
      this.currentRoom = this.roomToUpdate
    },
    formSubmit(e, roomStatus) {
      const f = new FormData(e)
      const getActionAccordingRoomStatus = (status, rp) => {
        const ob = {
          400: r => {
            this.roomSetData(r.data.rooms)
            this.editRoomDialog = false
          },
        }

        return (ob[status](rp) || ob[400](rp))
      }
      this.$axios.post(this.$endpoint.UpdateRoom(this.currentRoom.id), f).then(rp => getActionAccordingRoomStatus(roomStatus, rp)).then(() => {
        this.closeEditRoomDialog()
      })
    },
  },
}
</script>

<template>
  <div>
    <v-dialog
        v-model="active"
        fullscreen
        hide-overlay
        scrollable
        transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar
            class="p-0"
            color="primary"
            dark
            flat
        >
          <v-btn
              dark
              icon
              @click="closeEditRoomDialog"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
          <v-toolbar-title class="text-uppercase">
            Modification de chambre : {{currentRoom.name}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="pt-3">
            <v-btn
                class="text-uppercase"
                color="rgba(198, 48, 49,0.1)"
                dark
                @click="closeEditRoomDialog"
            >
              Fermer
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form
              class="multi-col-validation"
              @submit.prevent="formSubmit($event.target,400)"
          >
            <v-row
                class="pa-10"
            >
              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    v-model="currentRoom.room_name"
                    dense
                    hide-details
                    label="Numéro de la chambre"
                    name="room_name"
                    outlined
                    placeholder="Numéro"
                    required
                ></v-text-field>
              </v-col>

              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    v-model="currentRoom.room_create_date"
                    dense
                    hide-details
                    label="Date de création"
                    name="room_create_date"
                    outlined
                    placeholder="Création"
                    required
                    type="date"
                ></v-text-field>
              </v-col>

              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    v-model="currentRoom.room_unit_price"
                    dense
                    hide-details
                    label="Prix unitaire"
                    name="room_unit_price"
                    outlined
                    placeholder="prix"
                    required
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    v-model="currentRoom.room_total_price"
                    dense
                    hide-details
                    label="Prix de vente"
                    name="room_total_price"
                    outlined
                    placeholder="prix de vente"
                    required
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-select
                    v-model="currentRoom.room_type_id"
                    :item-text="'room_type_name'"
                    :item-value="'id'"
                    :items="roomtypes"
                    dense
                    label="Type de chambre"
                    name="room_type_id"
                    outlined
                    required
                ></v-select>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-select
                    v-model="currentRoom.apartment_id"
                    :item-text="'apart_bloc'"
                    :item-value="'id'"
                    :items="apartments"
                    dense
                    label="Block d'appartement concerné"
                    name="apartment_id"
                    outlined
                    required
                ></v-select>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-file-input
                    :value="defaultRoomInputFileValue"
                    dense
                    hide-details
                    label="Images de la chambre"
                    multiple
                    name="room_photos[]"
                    outlined
                    placeholder="Sélectionner les photos de la chambres"
                    required
                    type="file"
                ></v-file-input>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-select
                    v-model="currentRoom.room_state"
                    :item-text="'label'"
                    :item-value="'code'"
                    :items="roomStatus"
                    dense
                    label="Etat"
                    name="room_state"
                    outlined
                    required
                ></v-select>
              </v-col>
              <v-col
                  class="d-flex justify-center align-center"
                  cols="12"
                  md="12"
              >
                <v-radio-group
                    v-model="imagesAction"
                    name="file_action"
                    row
                >
                  <v-radio
                      :value="200"
                      class="mb-2"
                      label="Aucune modification d'image"
                  ></v-radio>
                  <v-radio
                      :value="202"
                      class="mb-2"
                      label="Modifier toutes les images"
                  ></v-radio>
                  <v-radio
                      :value="204"
                      class="mb-2"
                      label="Ajouter les nouvelles images aux anciennes"
                  ></v-radio>
<!--                  <v-radio-->
<!--                      :value="203"-->
<!--                      class="mb-2"-->
<!--                      label="Modifier une image"-->
<!--                      @click="selectImageToUpdateDialog=!selectImageToUpdateDialog"-->
<!--                  ></v-radio>-->
                </v-radio-group>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-textarea
                    v-model="currentRoom.room_description"
                    dense
                    required
                    name="room_description"
                    label="Description de la l'appart"
                    outlined
                ></v-textarea>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-select
                    v-model="currentRoom.room_spec ?currentRoom.room_spec.split(','): currentRoom.room_spec"
                    :items="commoditiesList"
                    :item-text="'label'"
                    multiple
                    dense
                    label="Commodités"
                    outlined
                    chips
                    name="room_spec">
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-btn
                    color="primary"
                    type="submit"
                >
                  Soumettre
                </v-btn>
                <v-btn
                    class="mx-2"
                    outlined
                    @click="closeEditRoomDialog"
                >
                  Annuler
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="selectImageToUpdateDialog"
        fullscreen
        hide-overlay
        scrollable
        transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar
            class="p-0"
            color="primary"
            dark
            flat
        >
          <v-btn
              dark
              icon
              @click="selectImageToUpdateDialog = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
          <v-toolbar-title class="text-uppercase">
            Sélectionner une image
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="pt-3">
            <v-btn
                class="text-uppercase"
                color="rgba(198, 48, 49,0.1)"
                dark
                @click="selectImageToUpdateDialog = false"
            >
              Fermer
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row
                class="d-flex justify-center align-center"
                dense
            >
              <v-radio-group
                  v-model="imageToUpdate"
                  row
              >
                <v-col
                    v-for="(image,index) in photosRoom(currentRoom.room_photos)"
                    :key="index"
                    md="4"
                    sm="6"
                    style="width: 300px"
                >
                  <v-card>
                    <v-img
                        :src="image"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="400px"
                    />
                    <v-card-actions class="d-flex justify-center align-center pa-3">
                      <v-radio
                          :value="image"
                      ></v-radio>
                      <v-btn
                          color="primary"
                          depressed
                          @click="showSigleImage(image)"
                      >
                        Voir&ensp;<v-icon>
                        {{ icons.mdiEye }}
                      </v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-radio-group>
            </v-row>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

</style>